import { TYPE_NUMBER } from './input-types';

export const id = 'amountPaid';
export const apiKey = 'AmountPaid';
export const type = TYPE_NUMBER;

export const amountPaid = {
  id,
  apiKey,
  type,
};
